import { render, staticRenderFns } from "./grupos.vue?vue&type=template&id=5d3b71af&scoped=true"
import script from "./grupos.vue?vue&type=script&lang=js"
export * from "./grupos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b71af",
  null
  
)

export default component.exports